import { segmentTrack } from '@/hooks/analytics/useTracking';
import { HtmlReportTrackingParams } from '@/models/HtmlReport';
import { snakeCaseKeys } from '@/utils/changeCase';

const htmlReportDisplayed = (params: HtmlReportTrackingParams) => {
  segmentTrack('Html Report Displayed', {
    event_schema_version: 2.0,
    event_type: 'technical',
    ...snakeCaseKeys(params),
  });
};

export default htmlReportDisplayed;
